/**
 * Created by rickborst on 24/04/2017.
 */

import _ from 'lodash';

import {
    ViewTreeActionTypes,
    ActiveViewStatuses
} from 'store/actions/viewtree';

const defaultViewTree = {
        views: {},
        activeViewStatus: ActiveViewStatuses.LOADING,
        activeView: null
    },

    /**
     * Returns the view path within the view tree.
     *
     * @param {Object} view - View object.
     * @returns {Array} Array representing view location.
     */
    getViewTreePath = function (view) {
        let currentView = view,
            location = [];

        do {

            location.push(currentView.id);
            currentView = currentView.parentView;
        } while (currentView);

        return location.reverse();
    },

    /**
     * Sets a view within the view tree state.
     *
     * @param {Object} state - Current state object.
     * @param {Object} view - View state.
     * @returns {Object} New state.
     */
    setView = function (state, view) {
        let viewPath = getViewTreePath(view),
            viewDepth = viewPath.length,
            currentPath = state;

        state = {...state};

        _.forEach(viewPath, function (location, index) {
            let isFinalLocation = index === viewDepth - 1;

            if (isFinalLocation) {

                currentPath.views[view.id] = {...view};
            } else {

                currentPath = currentPath.views[location];
            }
        });

        return state;
    },

    /**
     * Removes a view from the view tree state.
     *
     * @param {Object} state - Current state object.
     * @param {Object} view - View state.
     * @returns {Object} New state.
     */
    removeView = function (state, view) {
        let views;

        state = {...state};
        views = state.views;

        if (views[view.id]) {
            delete views[view.id];
        }

        return state;
    },

    /**
     * Sets the active view.
     *
     * @param {Object} state - Current state object.
     * @param {Object} view - New active view.
     * @returns {Object} New state.
     */
    setActiveView = function (state, view) {

        if (state.activeView !== view) {
            state = {
                ...state,
                activeView: view
            };
        }

        return state;
    },

    /**
     * Sets the active view status.
     *
     * @param {Object} state - Current state object.
     * @param {string} status - New active view status.
     * @returns {Object} New state.
     */
    setActiveViewStatus = function (state, status) {

        if (state.activeViewStatus !== status) {
            state = {
                ...state,
                activeViewStatus: status
            };
        }

        return state;
    },

    /**
     * Sets the active view background.
     *
     * @param {Object} state - Current state.
     * @param {Object} background - Background image.
     * @returns {Object} New state.
     */
    setViewBackground = function (state, background) {
        let currentBackground = _.get(state, ['activeView', 'background']);

        if (state.activeViewStatus !== ActiveViewStatuses.READY) {
            throw new Error(
                'Active view is not ready yet, please load ' +
                'the background after the view has been loaded.'
            );
        }

        if (currentBackground !== background) {

            state = {
                ...state
            };
            state.activeView.background = background;
        }

        return state;
    },

    /**
     * Updates rail.
     *
     * @param {Object} state - Current view tree state.
     * @param {Object} rail - New filled rail.
     * @returns {Object} Current/new state.
     */
    updateRail = function (state, rail) {

        state = {
            ...state,
            activeView: {
                ...state.activeView,
                modules: state.activeView.modules.map((module) => {
                    if (module.id === rail.id) {
                        return rail;
                    }
                    return module;
                })
            }
        };
        return state;
    },

    /**
     * Sets collection page reminder asset.
     *
     * @param {Object} state - Current view tree state.
     * @param {Object} reminder - Actions object.
     * @returns {Object} Current/new state.
     */
    setCollectionAssetReminder = function (state, reminder) {

        state = {
            ...state
        };

        let collectionAsset = _.get(state, ['activeView', 'modules', 0]);

        collectionAsset.setReminder(reminder);

        return state;
    },

    /**
     * Sets JUMBO page reminder asset.
     *
     * @param {Object} state - Current view tree state.
     * @param {Object} reminder - Actions object.
     * @param {number} reminderAssetId - Actions object.
     * @returns {Object} Current/new state.
     */
    setJumboAssetReminder = function (state, reminder, reminderAssetId) {

        let jumboRail = _.get(state, ['activeView', 'modules', 0]),
            {assets} = jumboRail;

        _.forEach(assets, (asset) => {
            if (asset.id === reminderAssetId) {
                asset.reminder = reminder;
            }
        });

        state = {
            ...state,
            activeView: {
                ...state.activeView
            }
        };

        return state;
    },

    /**
     * Sets the active view status.
     *
     * @param {Object} state - Current state object.
     * @param {string} status - New active view status.
     * @returns {Object} New state.
     */
    setLoadBlockerStatus = function (state, status) {
        if (state.loadBlockerStatus !== status) {
            state = {
                ...state,
                loadBlockerStatus: status
            };
        }

        return state;
    },

    /**
     * Returns the view tree state.
     *
     * @param {Object} state - Current view tree state.
     * @param {Object} action - Actions object.
     * @returns {Object} Current/new state.
     */
    viewTree = function (state = defaultViewTree, action) {

        switch (action.type) {

            case ViewTreeActionTypes.SET_VIEW:
                return setView(state, action.view);

            case ViewTreeActionTypes.REMOVE_VIEW:
                return removeView(state, action.view);

            case ViewTreeActionTypes.SET_ACTIVE_VIEW:
                return setActiveView(state, action.view);

            case ViewTreeActionTypes.SET_ACTIVE_VIEW_STATUS:
                return setActiveViewStatus(state, action.status);

            case ViewTreeActionTypes.SET_VIEW_BACKGROUND:
                return setViewBackground(state, action.background);

            case ViewTreeActionTypes.SET_RAIL:
                return updateRail(state, action.rail);

            case ViewTreeActionTypes.SET_REMINDER:
                return setCollectionAssetReminder(state, action.reminder);

            case ViewTreeActionTypes.SET_JUMBO_REMINDER:
                return setJumboAssetReminder(state, action.reminder, action.assetId);

            case ViewTreeActionTypes.SET_LOAD_BLOCKER_STATUS:
                return setLoadBlockerStatus(state, action.readyStatus);

            default:
                return state;
        }
    };

export default viewTree;


// WEBPACK FOOTER //
// ./src/js/store/reducers/viewtree.js